/* NON scroll reveal: one restrained arrival per meaningful content group. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || typeof IntersectionObserver === 'undefined') return;

  var TARGETS = [
    '.non-somm-section > *',
    '.non-poured',
    '.non-bottles__head',
    '.non-bottles__row',
    '.non-first-set__copy',
    '.non-first-set__media',
    '.non-press-globe__editorial',
    '.non-press-globe .non-globe',
    '.non-footer-card',
    '.non-facts__heading',
    '.non-facts__intro',
    '.non-facts:not(.non-facts--rotating) .non-facts__item',
    '.non-founder__portrait',
    '.non-founder__words',
    '.non-about-process__head > *',
    '.non-about-process__track',
    '.non-about-process__panels',
    '.non-pair__eyebrow',
    '.non-pair__heading',
    '.non-pair__intro',
    '.non-pair__axis',
    '.non-pair__verdict',
    '.non-matrix > *',
    '.non-recipes__head > *',
    '.non-recipes__intro',
    '.non-recipes__fridge > *',
    '.non-recipes__controls',
    '.non-recipes__trace',
    '.non-product-specs__heading',
    '.non-product-specs__item',
    '.non-product-pairings__head',
    '.non-product-pairing',
    '.non-product-occasions__head > *',
    '.non-product-occasion',
    '.non-process__copy > *',
    '.non-process__media',
    '.non-product-process__copy',
    '.non-product-process__media',
    '.non-stockist-hero > *',
    '.non-stockist-locator',
    '.non-contact__hero > *',
    '.non-contact__body > *',
    '.non-hq-hero > *',
    '.non-hq-fact',
    '.non-hq-room',
    '.non-hq-step',
    '.non-hq__hero-copy > *',
    '.non-hq__experience-grid article',
    '.non-hq__rooms figure',
    '.non-hq__happens li',
    '.nonhq__hero-copy > *',
    '.nonhq__facts > div',
    '.nonhq__rooms figure',
    '.nonhq__experiences header > *',
    '.nonhq__experience-list article',
    '.nonhq__booking > *',
    '.nonhq__happens > *',
    '.nonhq__press blockquote',
    '.nonhq__closer',
    '.non-origin__media',
    '.non-origin__body > *'
  ].join(',');

  var SECTION_ROOTS = 'main [id^="shopify-section-template"], main > .shopify-section';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });

  function mark(scope) {
    var delays = new Map();
    var root = scope || document;

    root.querySelectorAll(TARGETS).forEach(function (element) {
      if (element.hasAttribute('data-non-reveal')) return;
      element.setAttribute('data-non-reveal', '');

      /* Never animate the initial viewport; luxury motion should reward the
         scroll, not make the first paint wait for choreography. */
      if (element.getBoundingClientRect().top < window.innerHeight * 0.88) {
        element.classList.add('is-revealed');
        return;
      }

      var parent = element.parentElement;
      var index = delays.get(parent) || 0;
      delays.set(parent, index + 1);
      element.style.setProperty('--non-reveal-delay', Math.min(index, 4) * 85 + 'ms');
      observer.observe(element);
    });

    /* Baseline-native sections do not use NON class names. Give each section
       one restrained arrival unless it already owns detailed child reveals.
       This keeps motion consistent without double-animating custom builds or
       interfering with product controls, maps, drawers and app widgets. */
    root.querySelectorAll(SECTION_ROOTS).forEach(function (section) {
      if (section.hasAttribute('data-non-reveal')) return;
      if (section.querySelector('.non-home-hero')) return;
      if (section.querySelector('[data-non-reveal]')) return;
      if (section.hidden || section.getAttribute('aria-hidden') === 'true') return;

      section.setAttribute('data-non-reveal', '');
      section.setAttribute('data-non-reveal-section', '');

      if (section.getBoundingClientRect().top < window.innerHeight * 0.88) {
        section.classList.add('is-revealed');
        return;
      }

      observer.observe(section);
    });
  }

  function revealAll() {
    document.querySelectorAll('[data-non-reveal]:not(.is-revealed)').forEach(function (element) {
      element.classList.add('is-revealed');
    });
  }

  document.documentElement.classList.add('non-reveal-ready');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mark(document); });
  } else {
    mark(document);
  }

  /* Content must never depend on animation code remaining alive. */
  window.setTimeout(revealAll, 15000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') window.setTimeout(revealAll, 1200);
  });
  document.addEventListener('shopify:section:load', function (event) { mark(event.target); });
})();
